import { LogErrors } from './../LogErrors'

import { Login as DLLogin, Logout as DLLogout, ValidateSession as DLValidateSession, UpdateSessionInfo as DLUpdateSessionInfo, DeleteSessionInfo as DLDeleteSessionInfo } from './../DL/Sessions'
import * as WsStudent from './Student/ZtudentView'


const roles = {
    ZTUDENT: 1,
    INSTRUCTOR: 2,
    LEADER: 3,
    ADMINISTRATOR: 4
}

// Helper: evento propio para el MISMO tab
const dispatchAppLogout = () => {
    try { window.dispatchEvent(new Event('app:logout')) } catch {}
}

/**
 * 
 * @param {string} user 
 * @param {string} password 
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const Login = async (user, password) => {
    try {
        const response = await DLLogin(user, password)
        
        if (!response.success) {
            //No fue posible iniciar sesión
            return { success: false, message: response.message }
        }
        
        response.data.navigation = {
            "username": user
        }
        
        sessionStorage.setItem('userData', JSON.stringify(response.data))
    
        // Retornar la respuesta exitosa
        return { success: true, data: response.data }
    } catch (error) {
        await LogErrors('Login - Sessions BL', error)
        //return { success: false, message: 'errorNetwork' } // Código genérico para errores de red
        return { success: false, message: 2 }
    }
}

// /**
//  * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
//  */
/**
 * Cierra sesión “limpia”:
 * 1) Desconecta WS del Ztudiante (idempotente)
 * 2) Llama al endpoint de logout (si tienes token)
 * 3) Limpia sessionStorage
 * 4) Emite app:logout para que el Provider reaccione en el mismo tab
 * @returns {Object} { success: boolean, message?: string }
 */
const Logout = async () => {
    try {
        // 1) Desconectar WS primero (idempotente; si no está conectado, no pasa nada)
        try { WsStudent.disconnectStudent() } catch {}


        //Validar que exista la info del usuario en el session storage
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
        
        //Obtener la info del usuario desde el session storage
        const userData = await JSON.parse(sessionStorage.getItem('userData'))

        const token = userData?.token
        // if (!token) {
        //     return { success: false, message: '' }
        // }
        if (token) {
            await DLLogout(token)
            //const response = await DLLogout(token)
            // Podemos ignorar si falla: de todas formas procederemos a limpiar local
            // if (!response.success) {
            //     return { success: false, message: response.message }
            // }
        }

        // if (sessionStorage.getItem('userData')) {
        //     sessionStorage.removeItem('userData')
        // }
    
        // 3) Limpieza de sessionStorage (delegamos al DL para mantener tu arquitectura)
        await DeleteSessionInfo()

        // 3.1) Borrar info de progreso de avance
        await DeleteInstructorProgressData()

        // 4) Notificar a listeners del MISMO tab (Provider desconectará, etc.)
        dispatchAppLogout()

        return { success: true, data: null }
        // if (response.success) {
        //    return { success: true, data: null }
        // } else {
        //     return { success: flase, message: response.message }
        // }
    } catch (error) {
        await LogErrors('Logout - Sessions BL', error)
        return { success: false, message: 'No ha sido posible cerrar tu sesión correctamente. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}



const GetUserSessionData = async () => {
    try {
        const tmpUserData = sessionStorage.getItem('userData')

        if (tmpUserData) {
            return tmpUserData //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        } else {
            return null
        }
    } catch (error) {
        await LogErrors('GetUserSessionData - Sessions BL', error)
        return null
    }
}

/**
 * Función que valida si la sesión sigue activa
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const ValidateSession = async () => {
    try {
        // Validar que exista la info del usuario en el session storage
        const tmpUserData = await GetUserSessionData()
        if (!tmpUserData) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }
        
        // Obtener la info del usuario desde el session storage
        const userData = await JSON.parse(tmpUserData)
        if (!userData) {
            return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
        }

        const token = userData?.token
        if (!token) {
            sessionStorage.removeItem('userData')
            return { success: false, message: '' }
        }

        const response = await DLValidateSession(token)
        
        if (response.success) {
            return { success: true, data: userData }
        } else {
            sessionStorage.removeItem('userData')
            return { success: false, message: response.message } //Mensaje indicando que su sesión ha expirado.
        }
    } catch (error) {
        await LogErrors('ValidateSession - Sessions BL', error)
        return { success: false, message: '' }
    }
}

// const GetUserSessionData = async () => {
//     try {
//         const tmpUserData = sessionStorage.getItem('userData')

//         if (tmpUserData) {
//             return tmpUserData //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
//         } else {
//             return null
//         }
//     } catch (error) {
//         await LogErrors('GetUserSessionData - Sessions BL', error)
//         return null
//     }
// }

// /**
//  * Función que valida si la sesión sigue activa
//  * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
//  */
// const ValidateSession = async () => {
//     try {
//         // Validar si mandó el rol
//         if (!role) {
//             return { success: false, message: '' }
//         }

//         // Validar el rol que mandó para ver si está dentro de los permitidos
//         if (role === role.ZTUDENT || role === role.INSTRUCTOR || role === role.LEADER || role === role.ADMINISTRATOR) {
//             //Validar que exista la info del usuario en el session storage
//             // const tmpUserData = sessionStorage.getItem('userData')
//             // if (!tmpUserData) {
//             //     return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
//             // }
//             const tmpUserData = await GetUserSessionData()
            
//             //Obtener la info del usuario desde el session storage
//             const userData = await JSON.parse(tmpUserData)
//             if (!userData) {
//                 return { success: false, message: '' } //En este caso borraron los datos; así que le muestro mensaje indicando que su sesión ha expirado.
//             }
//             // //Comprobar varias propiedades para ver si está correcta la info del usuario
//             // if (userData.token === null || userData.token === '' || userData.user === null || userData.user.name === '') {
//             //     sessionStorage.removeItem('userData')
//             //     return { success: false, message: '' } //Mensaje indicando que su sesión ha expirado.
//             // }

//             const token = userData?.token
//             if (!token) {
//                 sessionStorage.removeItem('userData')
//                 return { success: false, message: '' }
//             }

//             // Temporalmente no enviar a validar la sessión del Instructor
//             if (role === role.INSTRUCTOR) {
//                 return { success: true, data: userData }
//             } else {
//                 const response = await DLValidateSession(token)
                
//                 if (response.success) {
//                     return { success: true, data: userData }
//                 } else {
//                     sessionStorage.removeItem('userData')
//                     return { success: false, message: response.message } //Mensaje indicando que su sesión ha expirado.
//                 }
//             }
//         } else {
//             return { success: false, message: '' }
//         }
//     } catch (error) {
//         await LogErrors('ValidateSession - Sessions BL', error)
//         return { success: false, message: '' }
//     }
// }

/**
 * @param {Array} sessionInfo 
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const UpdateSessionInfo = async (sessionInfo) => {
    try {
        const response = await DLUpdateSessionInfo(sessionInfo)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('UpdateSessionInfo - Sessions BL', error)
        return { success: false, message: '' }
    }
}

/**
 * Limpia la info local de sesión (sin llamar al backend)
 * 1) Desconecta WS (idempotente)
 * 2) Limpia sessionStorage
 * 3) Emite app:logout
 */
const DeleteSessionInfo = async () => {
    try {
        try { WsStudent.disconnectStudent() } catch {}

        const response = await DLDeleteSessionInfo()

        if (response.success) {
            // Notificar a listeners locales
            dispatchAppLogout()

            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('DeleteSessionInfo - Sessions BL', error)
        return { success: false, message: 'No ha sido posible limpiar la sesión' }
    }
}

//----- Instructor - Progreso de avance -----//

/**
 * Borrar la información de progreso del sessionStorage
 * @returns {boolean}
*/
const DeleteInstructorProgressData = async () => {
    try {
        sessionStorage.removeItem(process.env.REACT_APP_INSTRUCTOR_PROGRESS_VIEW)

        return { success: true, data: null }
    } catch (error) {
        await LogErrors('DeleteInstructorProgressData - Sessions BL', error)
        return { success: false, message: 'No ha sido posible borrar la información de progreso' }
    }
}

//----- Instructor - Progreso de avance -----//

export { Login, Logout, ValidateSession, UpdateSessionInfo, DeleteSessionInfo, DeleteInstructorProgressData }; 